import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Diseño Integral",
  "Fabricación a Medida",
  "Instalación Premium",
  "Remodelación Completa",
  "Closets y Vestidores",
  "Cubiertas y Mármol",
  "Carpintería Fina",
];

export default function MarqueeRibbon() {
  return (
    <section
      className="overflow-hidden border-y border-cream-border bg-cream-soft py-7"
      data-testid="marquee-section"
      aria-label="Servicios destacados"
    >
      <Marquee speed={32} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-2xl italic text-olive/75 md:text-3xl">
              {item}
            </span>
            <Asterisk
              className="mx-10 h-6 w-6 shrink-0 text-terracotta"
              strokeWidth={1.5}
            />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
